import { OnboardingTrialStepsType } from '@sdk/authentication/types';
import { useClientFlags } from '@sdk/session/ClientFlagsContext';

export type CompleteStep = (
  stepKey: OnboardingTrialStepsType,
  availableSteps: OnboardingTrialStepsType[]
) => Promise<void>;

export const useCompleteStep = (): CompleteStep => {
  const { updateClientFlags } = useClientFlags();

  const completeStep: CompleteStep = async (stepKey) => {
    updateClientFlags({
      [stepKey]: { key: stepKey, completed: true },
    });
  };

  return completeStep;
};
